import { render } from "./PontosIntalacao.vue?vue&type=template&id=677f38c2&scoped=true"
import script from "./PontosIntalacao.vue?vue&type=script&lang=js"
export * from "./PontosIntalacao.vue?vue&type=script&lang=js"

import "./PontosIntalacao.vue?vue&type=style&index=0&id=677f38c2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f38c2"]])

export default __exports__